import { User } from '../auth/auth.state'
import { Business } from '../business/business.state'

export enum LeaveType {
  LEAVEWITHOUTPAY = 'Leave Without Pay',
  CASUAL = 'Casual Leave',
  SICK = 'Sick Leave',
  MATERNITY = 'Maternity Leave',
  PATERNITY = 'Paternity Leave',
  BEREAVEMENT = 'Bereavement Leave', //Taken to attend the funeral or recover from the death of a close relative.
  COMPOFF = 'Compensatory Off',
  MARRIAGE = 'Marriage Leave',
  PL = 'Privilege Leave', //A type of paid leave accrued by employees based on their length of service, often taken for vacations or personal time off.
  RELIGIOUSFESTIVAL = 'Religious Festival Leave', //Leave granted to employees to observe their religious festivals.
  STUDY = 'Study Leave', //A type of leave granted to employees to pursue further education or training.
  SABBATICAL = 'Sabbatical Leave', // A longer period of unpaid leave (often months or a year) for personal development, travel, or other purposes.
  FLOATER = 'Floater Leave', //A "floater leave," also known as a floating holiday or floating day, is a paid day off that employees can use at their own discretion, often outside of the standard public holidays. Unlike fixed holidays, employees choose when they take these days off, allowing for flexibility and the ability to accommodate individual needs or preferences.
  WORKFROMHOME = 'Work From Home'
}

export interface LeavePolicy {
  id: string
  title: string
  description: string
  leaveType: LeaveType
  date: string
  disabled: boolean
  businessId: string
  business: Business
  encashable: boolean

  accrualMethod: string
  totalPerYear: number
  accrualFrequency: string
  accrualHappenPeriod: boolean
  isProbationPeriod: boolean
  probationPeriodLength: number
  maxLeaveBalanceCap: number
  IsMaxLeaveBalanceCap: boolean
  accruedProRataBasis: boolean
  proRataBasisDays: number
  waitingPeriodLength: number
  maxLeaveBalance: number

  resetHappen: string
  resetStart: string
  resetHappenPeriod: boolean
  leavesCarryForward: number
  futureResetCycle: boolean

  leaveAdvanceNoticePeriod: boolean
  leaveAdvanceNoticePeriodDay: number
  isHalfDay: boolean
  isQuarterDay: boolean
  maxConsecutiveLeaves: number
  isHolidayExcluded: boolean
  isWeekendExcluded: boolean
  isNagativeBalanceAllowed: boolean
  isDefault: boolean
  leaveTypeExclude: string[]

  createdAt: string
  updatedAt: string
  assignedCount: number
  currentBalance?: number
}

export interface AssignedTo {
  id: string
  leavePolicyId: string
  leavePolicy: LeavePolicy
  user: User
  userId: string
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  assignBy: string
  assignByUser: User
  currentBalance: number
}

export interface LeavePolicyState {
  totalCount: number
  leavepolicies: LeavePolicy[]
  assignedTo: AssignedTo[] | null
  loading: boolean
  error: string | null
  leavepolicy: LeavePolicy | null
  unassignedTo: User[]
  totalUserCount: number
}

export interface LeavePolicyDetailState {
  totalCount: number
  leavepolicy: LeavePolicy
  loading: boolean
  error: string | null
}
